module.exports = __webpack_public_path__ + "img/AT.33b4122a.svg";